import { modifier } from 'ember-modifier';
export default modifier(function setIndeterminate(element, [isIndeterminate]) {
  // eslint-disable-next-line no-param-reassign
  element.indeterminate = isIndeterminate;
});